






































































































































import InitialsAvatar from "@/components/misc/initials-avatar.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { User } from "@/swagger/models";
import { routes } from "@/router/router";
import { useUiStore } from "@/pinia/ui-store";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "navbar",
    components: { InitialsAvatar },
})
export default class Navbar extends Vue {
    uiStore = useUiStore();
    user: User | null = null;

    get routeParams() {
        return {
            customerId: this.$context.customer?.id,
            officeId: this.$context.office?.id,
        };
    }

    get displayedRoutes() {
        return routes
            .filter((r) => r.meta.includeInNavigation)
            .sort((r1, r2) => (r1.meta.order > r2.meta.order || !r1.meta.order ? 1 : -1));
    }

    get displayedSubroutes() {
        return routes
            .filter((r) => r.meta.includeInSubNavigation)
            .sort((r1, r2) => (r1.meta.order > r2.meta.order || !r1.meta.order ? 1 : -1));
    }

    get logoAlt() {
        return `v${process.env.VUE_APP_PACKAGE_VERSION} / ${process.env.VUE_APP_GITHUB_SHA || "hash unavailable"}`;
    }

    async mounted() {
        // Todo: When coming back from Okta, getUser may return undefined for a while
        // This is a little workaround, but should be fixed in the future.
        while (!this.user) {
            this.user = await this.$auth.getUser();
            await new Promise((r) => setTimeout(r, 250));
        }
    }
}
